module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-03-94bb15f7403a9c044e1c213445b9b89e.webp";